import styled from 'styled-components';

type arrowPosition = 'top' | 'right' | 'bottom' | 'left';

const Tooltip = styled.div<{ backgroundColor?: string }>`
  width: auto;
  margin: 0 auto;
  position: relative;
  text-align: left;
  z-index: 999;

  &:after {
    content: '';
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 5px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  }
  &:before {
    content: '';
    width: 20px;
    height: 20px;
    transform: rotate(45deg);
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
    background: ${props => props.backgroundColor || 'var(--white)'};
    position: absolute;
    z-index: 998;
    border-radius: 2px;
  }

  &.arrow-top:before {
    left: calc(50% - 10px);
    top: -8px;
  }
  &.arrow-right:before {
    top: calc(50% - 10px);
    right: -8px;
  }
  &.arrow-bottom:before {
    left: calc(50% - 10px);
    bottom: -8px;
  }
  &.arrow-left:before {
    top: calc(50% - 10px);
    left: -8px;
  }
`;

const Inner = styled.div<{ backgroundColor?: string }>`
   {
    width: 100%;
    padding: 18px;
    border-radius: 5px;
    background: ${props => props.backgroundColor || 'var(--white)'};
    position: relative;
    z-index: 998;
    box-sizing: border-box;
  }
`;

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  arrowPosition: arrowPosition;
  children: React.ReactElement;
  backgroundColor?: string;
}

const StaticTooltip = ({ backgroundColor, arrowPosition, children, ...props }: Props) => (
  <Tooltip backgroundColor={backgroundColor} className={`arrow-${arrowPosition}`}>
    <Inner backgroundColor={backgroundColor} {...props}>
      {children}
    </Inner>
  </Tooltip>
);

export default StaticTooltip;
